import { useSelector } from "react-redux";
import FilterSort from "./FilterSort";
import TranscriptItem from "./TranscriptItem";
import styles from "./styles.module.scss";
import { useState } from "react";

export default function TranscriptList({ title }) {
  const [searchTerm, setSearchTerm] = useState("");

  const transcripts = useSelector(
    (state) => state.filteredArchiveSlice.transcripts
  );

  const searchedData =
    transcripts &&
    transcripts.filter((transcript) =>
      transcript.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

  return (
    <div className={styles.wrapper}>
      <div className={styles.formHeader}>
        <div className={styles.titleContainer}>
          <svg className={styles.videoIcon}>
            <use xlinkHref="/icons/sprite.svg#icon-video"></use>
          </svg>
          <h1>{title}</h1>
        </div>
      </div>
      <div className={styles.transcriptArchive}>
        <div className={styles.transcriptListWrapper}>
          <div className={styles.transcriptListContainer}>
            {searchedData && searchedData.length > 0 ? (
              searchedData.map((transcript, index) => {
                if (
                  transcript.transcript_status !== "FAILED" &&
                  transcript.file_id !== ""
                ) {
                  return (
                    <TranscriptItem
                      key={index}
                      transcript={transcript}
                    />
                  );
                } else {
                  return null;
                }
              })
            ) : (
              <div className={styles.noTranscripts}>
                <h2>You don't have any transcripts yet.</h2>
                <a
                  href="/"
                  aria-label="Add new transcript"
                  className={styles.btn}
                >
                  Add your first transcript
                </a>
              </div>
            )}
          </div>
        </div>
        <div className={styles.filters}>
          <input
            type="text"
            placeholder="Search by title..."
            value={searchTerm}
            className={styles.searchInput}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <FilterSort />
        </div>
      </div>
    </div>
  );
}
